module.exports = __webpack_public_path__ + "c54595a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/li-logo.png
// module id = 657
// module chunks = 0 1 2 3 4